/**
 * Material UI theme utility
 * Generates preimage specific theme by extending MUI create theme
 */
import { grey } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";
import { TypographyOptions } from "@mui/material/styles/createTypography";

const typography: TypographyOptions = {
  fontFamily: 
    [
      "Poppins",
      "Roboto", 
      "Helvetica", 
      "Arial", 
      "sans-serif"
    ].join(","),
  h1: {
    fontSize: "1.5rem",
    fontWeight: "500",
    letterSpacing: '-2%'
  },
  h2: {
    fontSize: "1.25rem",
    fontWeight: "500",
  },
  h3: {
    fontSize: "1rem",
    fontWeight: "500",
  },
  h4: {
    fontSize: "1rem",
    fontWeight: "500",
  },
  h5: {
    fontSize: ".9rem",
    fontWeight: "500",
  }
};

const palette = {
  primary: {
    dark: "#4169e1",
    main: "#4169e1",
    light: "#33b4ff",
    contrastText: "#fff",
  },
};

const darkTheme = createTheme({
  palette: {
    ...palette,
    mode: "dark",
    background: {
      paper: '#111',
    },
    text: {
      primary: grey[50],
      secondary: grey[500],
    },
  },
  components: {
    MuiSkeleton: {
      styleOverrides: {
        root: {
          animation: "fade-in 1s", // Avoid flashing skeleton
        },
      },
    },
  },
  typography,
});

const lightTheme = createTheme({
  palette: {
    ...palette,
    mode: "light",
    background: {
      paper: grey[300],
    },
    text: {
      primary: grey[900],
      secondary: grey[500],
    },
  },
  typography,
});

const createPreimageTheme = (mode: "light" | "dark") => {
  if (mode === "dark") return darkTheme;
  if (mode === "light") return lightTheme;

  return createTheme({});
};

// const MARKER_COLORS = [
//   "#FF0000", // bright red
//   "#00FF00", // bright green
//   "#0000FF", // bright blue
//   "#FFFF00", // bright yellow
//   "#FF00FF", // bright magenta
//   "#00FFFF", // bright cyan
//   "#800000", // maroon
//   "#008000", // dark green
//   "#000080", // navy blue
//   "#808000", // olive green
//   "#FFA500", // orange
//   "#008080", // teal
//   "#800080", // purple
//   "#FFC0CB", // pink
//   "#FFD700", // gold
//   "#00FF7F", // spring green
//   "#7FFFD4", // aquamarine
//   "#DC143C", // crimson
//   "#00CED1", // dark turquoise
//   "#FF69B4", // hot pink
// ];

const MARKER_COLORS = [
  // "#FFADAD",
  // "#FFD6A5",
  // "#CAFFBF",
  "#FFB6C1", // Pastel Pink
  "#FFA07A", // Pastel Orange
  "#FFD700", // Pastel Yellow
  "#98FB98", // Pastel Green
  "#AFEEEE", // Pastel Turquoise
  "#ADD8E6", // Pastel Blue
  "#9370DB", // Pastel Purple
  "#DDA0DD", // Pastel Lavender
  "#FFA07A", // Pastel Peach
  // "#C71585", // Pastel Magenta
  "#BA55D3", // Pastel Orchid
  "#40E0D0", // Pastel Turquoise
  "#87CEEB", // Pastel Sky Blue
];

export { createPreimageTheme, MARKER_COLORS };
